export default function (url){
    let head = document.getElementsByTagName('head')[0];
    let style = document.createElement('link');
    style.href = url;
    style.rel = 'stylesheet'
    style.type = 'text/css';

    head.appendChild(style);

    return style;
}